// extracted by mini-css-extract-plugin
export default {"widget":"RiskValuesWidget_widget__fttLM","col":"RiskValuesWidget_col__CMPBZ","card":"RiskValuesWidget_card__ISFN+","container":"RiskValuesWidget_container__7TEO1"};